'use client'
import * as React from 'react'
import { useLocale, useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import type { PDPCategory } from 'cf-grpc/creativefabrica/content/v1/types_pb'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { addOrReplaceLocaleInUrl } from 'cf-i18n/helpers'

import {
  getIsProductFree,
  mapCategoryPageTypeToCategoryDetails,
} from '@web/components/content-api/config'

const ViewLicenseModal = dynamic(
  () => import('./view-license-content').then(module => module.ViewLicenseContent),
  {
    ssr: false,
  },
)

interface ViewLicenseLinkProps {
  category: PDPCategory
}

export function ViewLicenseLink({ category }: ViewLicenseLinkProps) {
  const t = useTranslations('prod.product_description_page.buy')
  const locale = useLocale()
  const [isOpen, setIsOpen] = React.useState(false)
  const isStockPhotos =
    category.root?.id === mapCategoryPageTypeToCategoryDetails.stockphotos.parentId
  const isColoringPage = getIsProductFree(category.root?.id)
  const Component = !isStockPhotos && !isColoringPage ? 'a' : 'button'
  const licenceLabelKey = isColoringPage ? 'license.label_pod' : 'license.label'

  return (
    <span className="inline-block py-1">
      {t.rich(licenceLabelKey, {
        b: str => <b className="font-bold">{str}</b>,
        link: str => (
          <Component
            tabIndex={0}
            className="text-cf-link cursor-pointer whitespace-nowrap underline hover:no-underline"
            {...(Component === 'button'
              ? {
                  onClick: () => {
                    setIsOpen(true)
                  },
                }
              : {
                  href: addOrReplaceLocaleInUrl(AppRoutes.SUBSCRIPTION_LICENCE, locale),
                  rel: 'noreferrer',
                  target: '_blank',
                })}
          >
            {str}
          </Component>
        ),
      })}
      {isOpen ? (
        <ViewLicenseModal isOpen={isOpen} setIsOpen={setIsOpen} category={category} />
      ) : null}
    </span>
  )
}
